import { Pet } from 'types/Pet';
import { Room } from 'types/Room';
import { isPetAllowedInRoom } from './roomRestrictions';
import { doesRoomUnitAllowPets } from './roomRuleSatisfaction';

export const getRoomUnitAssignmentsForPets = (
    room: Room,
    pets: Array<Pet>
): Array<number> | null => {
    if (room.room_units.length === 0) {
        return null;
    }

    if (!pets.every(pet => isPetAllowedInRoom(room, pet))) {
        return null;
    }

    const petsByUnit = room.room_units.map(() => [] as Array<Pet>);
    const assignments: Array<number | undefined> = new Array(pets.length).fill(undefined);

    const assignPetToUnit = (petIndex: number): boolean => {
        if (petIndex === pets.length) {
            return true;
        }

        const pet = pets[petIndex];

        for (let unitIndex = 0; unitIndex < room.room_units.length; unitIndex += 1) {
            const roomUnit = room.room_units[unitIndex];
            const unitPets = petsByUnit[unitIndex];

            unitPets.push(pet);

            if (doesRoomUnitAllowPets(room, roomUnit, unitPets)) {
                assignments[petIndex] = roomUnit.id;

                if (assignPetToUnit(petIndex + 1)) {
                    return true;
                }

                assignments[petIndex] = undefined;
            }

            unitPets.pop();
        }

        return false;
    };

    if (!assignPetToUnit(0)) {
        return null;
    }

    return assignments.every((assignment): assignment is number => assignment !== undefined)
        ? assignments
        : null;
};
